import { render, staticRenderFns } from "./VendorAllocation.vue?vue&type=template&id=3ec8720b&"
import script from "./VendorAllocation.vue?vue&type=script&lang=js&"
export * from "./VendorAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports